import type { IconProps } from '../types/IconProps.ts';
export const ArrowRightFromLine: IconProps = {
    name: 'ArrowRightFromLine',
    children: [
        `<path d="M7 12h12M3 5v14M15 6l5.85 5.65c.2.2.2.5 0 .7L15 18" />`,
    ]
};